import "@/App.css";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { BuiltFor } from "@/components/BuiltFor";
import { Services } from "@/components/Services";
import { Levers } from "@/components/Levers";
import { Process } from "@/components/Process";
import { Founder } from "@/components/Founder";
import { CaseStudies } from "@/components/CaseStudies";
import { FinalCta } from "@/components/FinalCta";
import { Footer } from "@/components/Footer";

function App() {
  return (
    <div className="App font-body">
      <Nav />
      <main>
        <Hero />
        <BuiltFor />
        <Services />
        <Levers />
        <Process />
        <Founder />
        <CaseStudies />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}

export default App;
